import { useCallback, useEffect, useState } from "react";
import { LogIn, ShieldAlert, Lock, RefreshCw } from "lucide-react";
import { api, coachHeaders, formatDateHeure } from "../lib/api";

const TYPES = {
  connexion: { Icon: LogIn, cls: "text-lime", label: (a) => `${a.nom ?? "?"} s'est connecté${a.role === "delegue" ? " (délégué)" : a.role === "coach" ? " (coach)" : ""}` },
  echec: { Icon: ShieldAlert, cls: "text-signal", label: (a) => `Code faux essayé${a.code ? ` : ${a.code}` : ""}` },
  blocage: { Icon: Lock, cls: "text-signal", label: () => "Appareil bloqué 15 min (codes faux)" },
  restauration: { Icon: RefreshCw, cls: "text-lime", label: (a) => `${a.nom ?? "?"} a restauré une sauvegarde (${a.fichier ?? ""})` },
};
const FILTRES = [["tout", "Tout"], ["connexion", "Connexions"], ["echec", "Codes faux"]];

export const AccessLog = ({ code }) => {
  const [rows, setRows] = useState([]);
  const [filtre, setFiltre] = useState("tout");
  const load = useCallback(() => {
    api.get("/admin/acces", coachHeaders(code)).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, [code]);
  useEffect(() => { load(); }, [load]);
  const shown = rows.filter((a) => filtre === "tout" || (filtre === "echec" ? ["echec", "blocage"].includes(a.type) : a.type === filtre));
  const echecs = rows.filter((a) => a.type === "echec").length;
  return (
    <div data-testid="access-log" className="rounded-2xl border border-line bg-pitch p-4">
      <div className="flex items-center justify-between gap-2">
        <h2 className="font-display text-2xl uppercase text-chalk">Journal des accès</h2>
        <button data-testid="access-log-refresh" onClick={load} aria-label="Actualiser" className="p-2 text-dim hover:text-lime"><RefreshCw className="h-4 w-4" /></button>
      </div>
      <p className="mt-1 text-sm text-dim">200 derniers événements, conservés 90 jours.{echecs > 0 && <span data-testid="access-log-echecs" className="text-signal"> {echecs} code{echecs > 1 ? "s" : ""} faux.</span>}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {FILTRES.map(([k, l]) => (
          <button key={k} data-testid={`access-log-filter-${k}`} onClick={() => setFiltre(k)}
            className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${filtre === k ? "border-lime bg-lime text-ink" : "border-line text-chalk hover:border-lime"}`}>{l}</button>
        ))}
      </div>
      <ul className="mt-3 max-h-[28rem] divide-y divide-line overflow-y-auto">
        {shown.length === 0 && <li data-testid="access-log-empty" className="py-3 text-sm text-dim">Aucun événement.</li>}
        {shown.map((a, i) => {
          const t = TYPES[a.type] ?? TYPES.echec;
          return (
            <li key={`${a.date}-${i}`} data-testid="access-log-row" className="flex items-start gap-3 py-2 text-sm">
              <t.Icon className={`mt-0.5 h-4 w-4 shrink-0 ${t.cls}`} />
              <div className="min-w-0 flex-1">
                <p className="text-chalk">{t.label(a)}</p>
                <p className="font-mono text-[11px] text-dim">{formatDateHeure(a.date)} · {a.appareil || "?"} · IP {a.ip}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
